module.exports = __webpack_public_path__ + "media/loader_desk_def.1b894fcc.webm";